<div class="configurator-v2" #top>
  <div class="configurator-v2__header">
    <div class="configurator-v2__header-inner">
      <wizard-steps
        class="configurator-v2__steps"
        [steps]="stepLabels"
        [current]="store.currentStep()"
        [maxReachable]="store.maxStep()"
        [completed]="store.submitted()"
        completedLabel="ProjectConfiguratorV2.Done.stepsLabel"
        variant="bars"
        (stepClick)="goTo($event)"
      />
    </div>
  </div>

  <div class="configurator-v2__body">
    <div class="configurator-v2__layout">
      <div class="configurator-v2__main">
        @if (!store.ready()) {
          <skeleton-item height="320px" />
        } @else if (store.submitted()) {
          <configurator-done (dashboard)="openDashboard()" />
        } @else {
          <configurator-step [step]="store.step()">
            @if (store.isReview()) {
              <configurator-review [cards]="review()" (edit)="editStep($event)" />
            }
          </configurator-step>
        }
      </div>

      @if (store.ready() && !store.submitted()) {
        <aside
          class="configurator-v2__summary"
          [class.configurator-v2__summary--open]="summaryOpen()"
          [attr.aria-label]="'ProjectConfiguratorV2.Summary.title' | translate"
        >
          <configurator-summary
            [groups]="summary()"
            (edit)="editStep($event)"
            (closed)="summaryOpen.set(false)"
          />
        </aside>

        @if (summaryOpen()) {
          <div class="configurator-v2__summary-scrim" (click)="summaryOpen.set(false)"></div>
        }

        @if (summaryCount()) {
          <button type="button" class="configurator-v2__summary-button" (click)="summaryOpen.set(true)">
            <svg-icon src="./assets/img/configurator/layers.svg" />
            {{ 'ProjectConfiguratorV2.Summary.title' | translate }}
            <span class="configurator-v2__summary-count">{{ summaryCount() }}</span>
          </button>
        }
      }
    </div>
  </div>

  @if (store.ready()) {
    <div class="configurator-v2__footer">
      <div class="configurator-v2__footer-inner">
        <div class="configurator-v2__footer-actions">
          @if (store.submitted()) {
            <app-button
              class="configurator-v2__footer-end"
              (onClick)="newRequest()"
              [config]="{
                size: ButtonSize.LARGE,
                type: ButtonTypes.PRIMARY_WHITE_BORDERED,
                text: 'ProjectConfiguratorV2.Nav.newRequest' | translate
              }"
            />
          } @else {
            @if (!store.isFirstStep()) {
              <app-button
                (onClick)="back()"
                [config]="{
                  size: ButtonSize.LARGE,
                  type: ButtonTypes.PRIMARY_WHITE_BORDERED,
                  text: 'ProjectConfiguratorV2.Nav.back' | translate,
                  prependSrc: './assets/img/ic-back-black.svg'
                }"
              />
            }

            <div class="configurator-v2__footer-end">
              @if (store.isReview()) {
                <app-button
                  (onClick)="submit()"
                  [config]="{
                    size: ButtonSize.LARGE,
                    type: ButtonTypes.NEW_PRIMARY_GREEN,
                    text: 'ProjectConfiguratorV2.Nav.submit' | translate
                  }"
                />
              } @else if (store.editReturn()) {
                <span class="configurator-v2__footer-hint">
                  {{ 'ProjectConfiguratorV2.Nav.editReturnHint' | translate }}
                </span>
                <app-button
                  (onClick)="next()"
                  [config]="{
                    size: ButtonSize.LARGE,
                    text: 'ProjectConfiguratorV2.Nav.save' | translate
                  }"
                />
              } @else if (!store.isLastStep()) {
                <app-button
                  (onClick)="next()"
                  [config]="{
                    size: ButtonSize.LARGE,
                    text: 'ProjectConfiguratorV2.Nav.next' | translate,
                    appendSrc: './assets/img/ic-chevron-right.svg'
                  }"
                />
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
